module.exports = __webpack_public_path__ + "img/ph.0c453bcc.png";